import LedgerMappingSidebarContainer from '../../ledger-mapping-sidebar/LedgerMappingSidebarContainer';
import React from 'react';
import { AppSidebar } from 'bk-web-app/app-sidebar';
import { Button } from 'bench-internal-theme';

type EditButtonProps = {
  connectionId: string;
};

const EditButton = ({ connectionId }: EditButtonProps) => (
  <AppSidebar>
    {({ closeSidebar, openSidebar }) => (
      <Button
        icon="pencil"
        styleType="primary"
        onClick={() =>
          openSidebar(
            <LedgerMappingSidebarContainer
              connectionId={connectionId}
              closeSidebar={closeSidebar}
            />,
          )
        }
      >
        Edit
      </Button>
    )}
  </AppSidebar>
);

export default EditButton;
